module.exports = __webpack_public_path__ + "img/icon-attach.83fc0598.svg";